export enum MyMusicTabs {
  Releases = "releases",
  Library = "library",
}

interface MyMusicTabsValue {
  value: MyMusicTabs;
  label: string;
}

export const MyMusicTabsMapping: Record<string, MyMusicTabsValue> = {
  [MyMusicTabs.Releases]: {
    value: MyMusicTabs.Releases,
    label: "Releases",
  },
  [MyMusicTabs.Library]: {
    value: MyMusicTabs.Library,
    label: "Library",
  },
};
